<template>
  <!-- 半屏的供应商批量下单页面   class="container" -->
  <div>
    <el-tabs v-model="activeTabsName" @tab-click="handleTabsClick" type="border-card">
      <el-tab-pane v-if="showAuto" label="通用批量查询" name="0">
        <wh-bo-auto ref="boAuto"></wh-bo-auto>
      </el-tab-pane>
      <el-tab-pane label="书名批量查询" name="1">
        <wh-bo-productname ref="boProductname"></wh-bo-productname>
      </el-tab-pane>
      <el-tab-pane label="ISBN批量下单" name="2">
        <wh-bo-isbn ref="boISBN"></wh-bo-isbn>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import whBoAuto from './whBoAuto';
import whBoIsbn from './whBoIsbn';
import whBoProductname from './whBoProductname';
import $store from '../../store'
export default {
  name: "batchOrder",
  data() {
    return {
      activeTabsName: "1",
      // 通用版对下面账号屏蔽
      autoExcludeAccount: [],//'新凯文化', '行知兰台'
      showAuto: false,
    };
  },
  components: {
    whBoAuto,
    whBoIsbn,
    whBoProductname,
  },
  computed: {
    ...mapGetters(["isNaName"]),
    
  },
  mounted() {
    this.showAuto = !this.autoExcludeAccount.includes($store.state.userInfo.loginAccount);
    if (this.showAuto) this.activeTabsName = "0";
  },
  methods: {
    handleTabsClick() {
      if (this.activeTabsName === "2") {
        this.$refs.boISBN.getBatchOrder();
      } else if (this.activeTabsName === "1") {
        this.$refs.boProductname.getBatchOrder();
      }
    },
    tologin1() {
      this.$message({
        message: "请登录供应商身份账号！",
        type: "warning",
      });
      this.$router.push("/loginProvider");
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
